

import '../services/packageTypeService';
import { IPackageTypeService } from '../services/packageTypeService';
import '../../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import { PackageType } from '../models/packageType';
import { RequestPackages } from '../../../models/requestPackages';
import { RequestDetailEdit } from '../../../models/requestDetailEdit';
import { RequestMaterial } from '../../../models/requestMaterial';
import '../templates/packageDialog.scss';


export default class PackageDialogController {

    static $inject = ['$mdDialog', 'packageTypeService', '$q'];
    private _packageTypesList: PackageType[];
    selectedPackageType: PackageType;
    newRequestPackages: RequestPackages;
    requestDetailEdit: RequestDetailEdit;
    isNewPackage: boolean;
    editIndex: number;
    isLoading: boolean;


    constructor(private _$mdDialog: ng.material.IDialogService,
        private _packageTypeService: IPackageTypeService,
        private $q: ng.IQService
    ) {

    }

    $onInit(): void {
        this.isLoading = true;
        this.populateInitialValues();
        if (this.isNewPackage === false) {
            this.newRequestPackages = angular.copy(this.requestDetailEdit.requestMaterial
                .requestPackages[this.editIndex]);
            if (this.newRequestPackages.packageTypeId !== undefined &&
                this.newRequestPackages.packageTypeId !== null) {
                this.selectedPackageType = new PackageType(this.newRequestPackages.packageTypeId,
                    this.newRequestPackages.packageType);
            }

        } else if (this.isNewPackage) {
            if (this.newRequestPackages === undefined || this.newRequestPackages === null) {
                this.newRequestPackages = new RequestPackages(undefined);
            }
            this.newRequestPackages.uom = 'IN';
        }
    }

    isPackageTypeEnvelope(): boolean {
        if (this.newRequestPackages !== undefined &&
            this.newRequestPackages !== null &&
            this.newRequestPackages.packageTypeId !== undefined &&
            this.newRequestPackages.packageTypeId !== null &&
            this.newRequestPackages.packageTypeId.toLowerCase() === "envelope") {
            this.newRequestPackages.length = undefined;
            this.newRequestPackages.width = undefined;
            this.newRequestPackages.height = undefined;
            this.newRequestPackages.uom = 'IN';
            return true;
        }
        return false;
    }

    populateInitialValues(): void {
        const deferred = this.$q.defer();

        this.$q.all([this.populatePackageTypes()])
            .then((values) => {
                this.handleGetPackageTypes(values[0]);
                this.isLoading = false;
            })
            .catch((response) => {
                deferred.reject(this.getErrorReason(response.status));
            });

    }

    private populatePackageTypes(): ng.IPromise<PackageType[]> {
        const deferred = this.$q.defer<PackageType[]>();
        this._packageTypeService.getPackageTypes()
            .then((packageTypes) => {
                deferred.resolve(packageTypes);
            })
            .catch((response) => {
                deferred.reject(response);
            });
        return deferred.promise;
    }


    private getErrorReason(status: any): string {
        var value = 'error';
        if (status !== undefined && status.toString() === "401")
            value = 'timeout';
        return value;
    }


    handleGetPackageTypes(options: any) {
        this._packageTypesList = options;
    }


    get packageTypeList(): Array<PackageType> {
        return this._packageTypesList;
    }


    cancel(): void {
        this._$mdDialog.cancel();
    }

    save(): void {
        this._$mdDialog.hide();
        if (this.isNewPackage === false) {
            this.newRequestPackages.recordNumber = this.editIndex;
            this.requestDetailEdit.requestMaterial.requestPackages[this.editIndex] = angular.copy(this.newRequestPackages);
            this.loadPackagesToAssignMaterialsOnSave(angular.copy(this.editIndex),
                angular.copy(this.newRequestPackages));
           
        } else {

            if (this.requestDetailEdit !== undefined &&
                this.requestDetailEdit.requestMaterial !== undefined &&
                this.requestDetailEdit.requestMaterial.requestPackages.length > 0) {
                const nextIndex = this.requestDetailEdit.requestMaterial.requestPackages.length;
                this.newRequestPackages.recordNumber = angular.copy(this.findNextRecordNumberForPackages(angular.copy(this.requestDetailEdit)));
                this.requestDetailEdit.requestMaterial.requestPackages[nextIndex] = angular
                    .copy(this.newRequestPackages);
                this.loadPackagesToAssignMaterialsOnSave(angular
                    .copy(nextIndex),
                    angular.copy(this.newRequestPackages));
            } else {
                this.newRequestPackages.recordNumber = 0;
                this.requestDetailEdit.requestMaterial.requestPackages[0] = angular.copy(this.newRequestPackages);
                this.loadPackagesToAssignMaterialsOnSave(angular.copy(0), angular.copy(this.newRequestPackages));
            }

          
        }

    }


    private findNextRecordNumberForPackages(requestDetailEdit: RequestDetailEdit): number {
        var nextPackageRecordNumber: number = 0;
        if (requestDetailEdit !== undefined &&
            requestDetailEdit.requestMaterial !== undefined &&
            requestDetailEdit.requestMaterial.requestPackages.length > 0) {

            for (var eachRequestPackage of requestDetailEdit.requestMaterial.requestPackages) {
                if (nextPackageRecordNumber <= eachRequestPackage.recordNumber) {
                    nextPackageRecordNumber = angular.copy(eachRequestPackage.recordNumber);
                }
            }
        }
       
        return nextPackageRecordNumber + 1;
    }



    private loadPackagesToAssignMaterialsOnSave(packageEditIndex : number , rqPackage :  RequestPackages) {
        for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; i++) {
            if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages === undefined ||
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages === null  ) {
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages = [];
            }
            this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i]
                .requestPackages[packageEditIndex] = angular.copy(rqPackage);

            this.calculateAssignedPcOfAssignedMaterials();

        }
    }

    private calculateAssignedPcOfAssignedMaterials() {
        for (var iam = 0; iam < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
            if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam] !== undefined &&
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials !==
                undefined &&
                !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials
                .isDeleted) {
                var assignedPc = 0;
                for (let assignedMaterialRequestPackage of this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestPackages.filter(o => !o.isDeleted) ) {

                    assignedPc = assignedPc + (assignedMaterialRequestPackage.quantity !== undefined && assignedMaterialRequestPackage.quantity !== null ?  
                        assignedMaterialRequestPackage.quantity :  0);
                }

                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].assignedPc = angular
                    .copy(assignedPc);
            }
        }
    }


    packageTypeChanged(): void {
        if (this.newRequestPackages === undefined || this.newRequestPackages === null) {
            this.newRequestPackages = new RequestPackages(undefined);
        }

        this.newRequestPackages.packageTypeId = this.selectedPackageType.packageTypeId;
        this.newRequestPackages.packageType = this._packageTypesList.filter(x => x.packageTypeId === this.selectedPackageType.packageTypeId)[0].description; 
        
    }

    shouldDisableSave(): boolean {
        return false;
    }


}

angular
    .module('deliveryCreate.app')
    .component('packageDialog',
    {
        template: require('../templates/packageDialog.html'),
        controller: PackageDialogController,
        controllerAs: 'vm',
        bindings: {
            requestDetailEdit: '=',
            isNewPackage: '=',
            editIndex: '='
            
        }
    });


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/packageDialog/controllers/packageDialogController.ts
 **/